const SocketEventEnum = Object.freeze({
  SOCKET_CONNECTED: "connected",
  SOCKET_DISCONNECTED: "disconnect",
  SOCKET_ERROR: "socketError",
  POST_REACT: "post_react",
  JOIN_POST: "joinPost",
  JOIN_LIVE_SHORT: "joinShort",
  COMMENT_REACT: "commentReact",
  CREATE_COMMENT: "createComment",
  EDITED_COMMENT: "edited_comment",
  REPLY_COMMENT: "replyComment",
  DELETE_COMMENT: "deleteComment",
  JOIN_CONVERSATION: "joinConversation",
  JOIN_LIVE_STREAM: "joinLiveStream",
  HOST_LEFT_LIVE_STREAM: "hostLeftLiveStream",
  HOST_JOIN_LIVE_STREAM: "hostJointLiveStream",
  HOST_END_LIVE_STREAM: "hostEndLiveStream",
  SEND_MESSAGE_TO_CONVERSATION: "sendMessageToConversation",
  SEND_CONVERSATION_REQUEST: "addConversation",
  MESSAGE_RECEIVED: "messageReceived",
  TYPING: "typing:start",
  DISPLAY_TYPING: "displayTyping",
  ONLINE: "user:online",
  OFFLINE: "user:offline",
  OUTGOING_CALL: "outgoing:call",
  INCOMING_CALL: "incoming:call",
  CALL_REJECTED: "call:rejected",
  CALL_ACCEPTED: "call:accepted",
  CALLER_LEFT: "caller_left",
  CALL_TIMEOUT: "call_timeout",
  LIVE_VIEW_COUNT: "liveViewCount",
  LIVE_CHAT_SEND: "liveChatSend",
  USER_KICK_FROM_LIVE: "user_kick_from_live",
  BAN_VIEWER_FROM_MY_LIVE_STREAM: "ban_user_from_my_live_stream",
  NOTIFY_USER: "notify_user",
  FOLLOW_USER: "follow_user",
  UNFOLLOW_USER: "unfollow_user",
  DELETE_CONVERSATION: "delete_conversation",
  REACT_CONVERSATION_MESSAGE: "react_conversation_message",
  REMOVE_REACT_CONVERSATION_MESSAGE: "remove_react_conversation_message",
  EDITED_CONVERSATION: "edit_conversation_message",
  DELETE_CONVERSATION_MESSAGE: "delete_conversation_message",
  UNDO_DELETE_CONVERSATION_MESSAGE: "undo_conversation_message",
  READ_MESSAGE: "read_message",
  SHORT_REACT: "shortReact",
  CREATE_SHORT_COMMENT: "createShortComment",
  SHORT_REPLY_COMMENT: "shortReplyComment",
  SHORT_EDITED_COMMENT: "shortEditedComment",
  SHORT_DELETE_COMMENT: "shortDeleteComment",
  FORCE_LOGOUT: "forceLogout",
  POST_COMPLETED: "post:completed",
  POST_FAILED: "post:failed",
  POST_UPDATE_COMPLETED: "post:update:complete",
  POST_UPDATE_FAILED: "post:update:failed",
  POST_CREATED: "post:created",

});

export default SocketEventEnum;
